import getAxiosClient from "./getAxiosClient";

const service = getAxiosClient();

export default service;
